var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 34,
    rx: 8,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 10.5002H17.1667C17.765 10.5002 18.25 10.0151 18.25 9.41683C18.25 8.81852 17.765 8.3335 17.1667 8.3335H12.8333C12.235 8.3335 11.75 8.81852 11.75 9.41683C11.75 10.0151 12.235 10.5002 12.8333 10.5002Z",
    fill: "#83888E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 15.9168H12.8333C12.235 15.9168 11.75 16.4019 11.75 17.0002C11.75 17.5985 12.235 18.0835 12.8333 18.0835H17.1667C17.765 18.0835 18.25 17.5985 18.25 17.0002C18.25 16.4019 17.765 15.9168 17.1667 15.9168Z",
    fill: "#83888E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 23.5002H12.8333C12.235 23.5002 11.75 23.9852 11.75 24.5835C11.75 25.1818 12.235 25.6668 12.8333 25.6668H17.1667C17.765 25.6668 18.25 25.1818 18.25 24.5835C18.25 23.9852 17.765 23.5002 17.1667 23.5002Z",
    fill: "#83888E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButton);
export default __webpack_public_path__ + "static/media/Action_Button.bed63d89b819d0c32e24100890867bbb.svg";
export { ForwardRef as ReactComponent };